export class NatureFollowerProject{

     id: number;
	 name: string;
	 abbreviation: string;
     observation: string;
     
     constructor(){}
}

export class NatureFollowerProjectForm{

    id: number;
    name: string;
    abbreviation: string;
    observation: string;
    
    constructor(){}
}
